export default {
  API_ERROR: "Je nám ľúto, niečo sa pokazilo. Skúste to znova.",
  FORM_ERROR: "Ospravedlňujeme sa, ale musíte napísať trochu viac, aby ste nám mohli poskytnúť spätnú väzbu."
}
